export const GOOGLE_MAP_API_PROVIDER_KEY =
  'AIzaSyDa8wembMQGYBODTXWqdvajkAeZvazz4iU'
